import { apiClient } from '@src/services/http-common'
import { getClosestLoan } from '@src/services/loanService'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { Person } from './@types/GetPersonDTO'
import { GetPersonResultDTO } from './@types/GetPersonResultDTO'

const SCOPE = 'list'
const LOANS = 'loans'

const fetchPerson = async (): Promise<Person> => {
  const response = await apiClient.get<Person>('/Person');
  return response.data;
};

export const useFetchPerson = (): [Person | null, boolean] => {
  const { data, isLoading } = useQuery<Person, Error>({
    queryKey: [SCOPE, LOANS],
    queryFn: fetchPerson,
    staleTime: 1000 * 60 * 5,
  })
  return [data ?? null, isLoading];
};

export const useGetActivePersonLoan = (
  initialLoanId?: string,
): [GetPersonResultDTO | undefined, string | undefined, boolean] => {
  const [personData, isLoadingPerson] = useFetchPerson();

  const activeLoanId =
   initialLoanId ?? (personData?.loans.length ? getClosestLoan(personData.loans).id.toString() : undefined);

  const activeLoan = useMemo(
    () => personData?.loans.find((loan) => loan.id.toString() === activeLoanId),
    [personData?.loans, activeLoanId],
  );

  return [activeLoan, activeLoanId, isLoadingPerson];
};